"use client";

import { useEffect } from "react";
import { hasConsent } from "@/lib/analytics/consent";
import { loadOpenAIPixel } from "@/lib/analytics/openai-pixel";

const PIXEL_ID = process.env.NEXT_PUBLIC_OPENAI_PIXEL_ID;

/**
 * Loads the ChatGPT Ads pixel once the visitor has given marketing consent,
 * like the Google Ads tags in GTM. The pixel reads the `oppref` click id from
 * the URL at init; ClickIdPassthrough keeps it in the URL until then, since
 * most visitors consent first at "Fortsätt" in /boka. Purchases are sent from
 * `bookingConfirmed` (lib/analytics/events.ts).
 */
export default function OpenAIPixel() {
  useEffect(() => {
    if (!PIXEL_ID) return;
    const pixelId = PIXEL_ID;
    const sync = () => {
      if (hasConsent("marketing")) loadOpenAIPixel(pixelId);
      else window.oaiq?.("consent", false);
    };
    sync();
    window.addEventListener("uk:consent-changed", sync);
    return () => window.removeEventListener("uk:consent-changed", sync);
  }, []);

  return null;
}
